import commonPostTypeConfig from '../../common/postTypes/method'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'method',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
